import jwtDecode from "jwt-decode";
import { verify, sign } from "jsonwebtoken";
import { axiosInstance } from "./axios";

const isValidToken = (accessToken) => {
  if (!accessToken) {
    return false;
  }
  const decoded = jwtDecode(accessToken);
  const currentTime = Date.now() / 1000;

  return decoded.exp > currentTime;
};

const handleTokenExpired = (exp) => {
  let expiredTimer;

  window.clearTimeout(expiredTimer);
  const currentTime = Date.now();
  const timeLeft = exp * 1000 - currentTime;
  // console.log(timeLeft);
  expiredTimer = window.setTimeout(() => {
    // console.log("expired");
  }, timeLeft);
};

const setSession = (accessToken, rememberMe = true) => {
  if (accessToken) {
    if (rememberMe) {
      localStorage.setItem("accessToken", accessToken);
    } else {
      sessionStorage.setItem("accessToken", accessToken);
      localStorage.removeItem("accessToken");
    }
    axiosInstance.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    // This function below will handle when token is expired
    const { exp } = jwtDecode(accessToken);
    handleTokenExpired(exp);
  } else {
    localStorage.removeItem("accessToken");
    sessionStorage.removeItem("accessToken");
    localStorage.removeItem("rbacPermissions");
    delete axiosInstance.defaults.headers.common.Authorization;
  }
};

export { verify, sign, isValidToken, setSession, handleTokenExpired };
